import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";
import Modal from 'react-bootstrap/Modal';

import './Users.css';

export default function UserMfaConfirm({ userEmail, password, mfaId, showModal, mfaConfirm }) {
    const [show, setShow] = useState(showModal);
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: {
            "email": userEmail,
            "password": password,
            "mfaId": mfaId,
            "mfaCode": ""
        }
    });

    const handleClose = () => {
        setShow(false);
    };
    const handleShow = () => {
        //setValue("email", userEmail);
        setValue("mfaCode", "");
        setShow(true);
    }

    const onSubmit = async (data) => {
        console.log(data);
        if (show) {
            console.log(`submitted`);
            mfaConfirm(data);
        } else {
            console.log("DONT SUBMIT");
            return;
        }
    };

    return (
        <div>
            <Modal show={show} onHide={handleClose} centered dialogClassName="user-edit-modal-size" contentClassName="user-edit-modal-content">
                <Modal.Header closeButton>
                    <Modal.Title>Special Agent - Control Panel</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body align="center">
                        <div><h2><b>Verify Your Identity</b></h2></div>
                        <input type="hidden" {...register("email")} />
                        <input type="hidden" {...register("password")} />
                        <input type="hidden" {...register("mfaId")} />
                        <div>An email has been sent with a one-time passcode</div>
                        <div>
                            <input type="password" placeholder="Enter the 6-digit code" className="user-mfa-confirm-field" maxLength="6" {...register("mfaCode", { required: true })} />
                        </div>
                        <button type="submit" className="button-base user-mfa-confirm-button" align="center">
                            Continue
                        </button>
                    </Modal.Body>
                </form>
            </Modal>
        </div>
    )
}

UserMfaConfirm.propTypes = {
    userEmail: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    mfaId: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    mfaConfirm: PropTypes.func.isRequired
}
